/* eslint-disable react-hooks/exhaustive-deps */
import { Divider } from 'antd'
import { Publication } from 'src/core/models'
import { useQuery } from '@tanstack/react-query'
import { getPublicationsAPI } from 'src/features'
import React, { useEffect, useState } from 'react'
import { CustomCard, CustomTable } from 'src/components'
import { getFilteredPublications } from 'src/core/helpers'
import { publicationListColumns } from 'src/core/table-columns'
import PublicationUrlsList from './PublicationUrlsList/PublicationUrlsList'
import PublicationListHeader from './PublicationListHeader/PublicationListHeader'

const PublicationsPageContent: React.FC = () => {
  const { isLoading, data } = useQuery<Publication[]>(['publications'], getPublicationsAPI)
  const bigPublicationList = data || []
  const [filterText, setFilterText] = useState<string>(null)
  const [filteredPublications, setFilteredPublications] = useState<Publication[]>(bigPublicationList || [])

  useEffect(() => {
    const publicationsFiltered = getFilteredPublications(filterText, bigPublicationList)
    setFilteredPublications(publicationsFiltered)
  }, [filterText, data])

  const tableProps = {
    dataSource: filteredPublications,
    columns: publicationListColumns,
    rowKey: (item: Publication) => item.id,
    rowClassName: 'fade-animation pointer',
    pageSize: 10,
    expandIconColumnIndex: 3,
    expandable: {
      expandRowByClick: true,
      expandedRowRender: (publication: Publication) => {
        return <PublicationUrlsList publicationUrls={publication.urls} />
      }
    },
  }

  return (
    <div className='fade-animation'>
      <CustomCard loading={isLoading}>
        {/* Header */}
        <PublicationListHeader
          filterText={filterText}
          onChange={(value) => setFilterText(value)}
          length={filteredPublications.length}
        />
        <Divider />

        {/* List */}
        <CustomTable {...tableProps} />
      </CustomCard>
    </div>
  )
}

export default PublicationsPageContent
